// © 2026 AttainIP Engineering

/**
 * Waypoints — suggested follow-up actions rendered as clickable buttons.
 * Vertically stacked, #ede9e3 fill (matches the Attain's recommendation
 * panel in OA Review so the two "Attain speaks" surfaces share a fill),
 * burgundy text and 16px padding. The stack gap is a hard 10px across
 * every chat surface.
 */

interface WaypointsProps {
  waypoints: string[];
  onSelect: (text: string) => void;
  disabled?: boolean;
}

export function Waypoints({ waypoints, onSelect, disabled }: WaypointsProps) {
  if (waypoints.length === 0) return null;

  return (
    <div className="flex flex-col gap-[10px] mt-[12px]">
      {waypoints.map((wp, i) => (
        <button
          key={i}
          onClick={() => onSelect(wp)}
          disabled={disabled}
          className="block w-full text-left
                     p-[16px] text-[13px] leading-[16px]
                     text-[var(--color-ink-900)] bg-[#f0eef2]
                     border border-transparent
                     rounded-[var(--radius-md)] cursor-pointer
                     hover:bg-[#E7E3EA] hover:border-[#CEC7D4]
                     hover:shadow-[0_2px_5px_rgba(51,0,31,0.07)]
                     active:shadow-[0_1px_3px_rgba(51,0,31,0.05)]
                     disabled:opacity-50 disabled:cursor-not-allowed
                     transition-[background-color,border-color,box-shadow] duration-[380ms]
                     ease-[cubic-bezier(0.16,1,0.3,1)]"
        >
          {wp}
        </button>
      ))}
    </div>
  );
}
